import axios from '../../../utils/request';

function GET_LIST(params) {
    return axios.get("/inquiry/AInquiry/index",{
        params: {
            page:params
        }
    } )
}
function GET_INFO(params) {
    return  axios.get("/inquiry/AInquiry/getInfo",{
        params: {
            id:params
        }
    } )
}
function EXPORT(params) {
    return  axios.get("/inquiry/AInquiry/exportExcel",{
        params: {
            ids:params
        }
    }  )
}

function DELE(params) {
    return  axios.get("/inquiry/AInquiry/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LIST,
    GET_INFO,
    EXPORT,
    DELE
};